import request from '@/Utilities/httpRequest';

export class BackEndContent {
    public static async get(url: string, paramsData: Object, retry: boolean): Promise<any> {
        let keys = Object.keys(paramsData);
        let token = null;

        if(keys.length == 0){
            return {};
        }

        try{
            token = btoa(JSON.stringify({
                keys: keys,
                bulk: true,
                version: 'v2',
                retray: retry
            }));
        }catch(e){}

        let params: any = { data: paramsData, version: 'v2', retray: retry };
        const response = await request.post(url, params, false, { 'Content-Type': 'application/json', 'Blocks-Info': token });
        let status = response.status ?? 200;
        if (!retry && ((status == 500 || status == 204) || !(response?.data ?? null))) {
            return this.get(url, paramsData, true);
        }
        
        return response.data ?? {};
    }
}